<dashboard-loader *ngIf="isEdit && (loadingSelectedStudy$ | async)" [title]="'Loading Study...'"></dashboard-loader>
<div
  *ngIf="(isEdit && (selectedStudyLoaded$ | async)) || !isEdit"
  class="dashboard-study-details"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="dashboard-study-details__title">Study details</div>
  </div>
  <form
    [formGroup]="studyDetailsForm"
    dashboardConnectForm
    [connectForm]="isEdit ? selectedStudy : null"
    class="dashboard-study-details__form"
    fxLayout="column"
    fxLayoutAlign="space-between stretch"
    fxLayoutGap="20px"
  >
    <div fxLayout="column" fxLayoutGap="10px">
      <label class="dashboard-study-details__form-label">Type of survey</label>
      <div fxLayout="row">
        <mat-button-toggle-group
          disabled
          name="studyType"
          aria-label="Study Type"
          fxLayout="row"
          fxLayout.lt-md="column"
          [value]="selectedStudyType"
        >
          <mat-button-toggle [value]="StudyType.TIIM">{{ 'TIIM Survey' | uppercase }}</mat-button-toggle>
          <mat-button-toggle [value]="StudyType.CC">{{ 'Career Compass Survey' | uppercase }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>

    <div>
      <mat-tab-group
        mat-align-tabs="end"
        (selectedTabChange)="selectTemplateLanguage($event)"
        #languageTabs
        [disablePagination]="true"
        [selectedIndex]="selectedLanguage?.tabIndex"
        (animationDone)="selectFirstTab()"
      >
        <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </mat-tab>
      </mat-tab-group>
      <ng-template #tabContent>
        <div formArrayName="studyTranslations" *ngFor="let item of studyTranslations.controls; let i = index">
          <mat-form-field [formGroupName]="i" *ngIf="item.get('language').value === selectedLanguage.code" fxFlex="100">
            <input
              matInput
              formControlName="translation"
              [placeholder]="item.get('identifier').value === 'title' ? 'Study title' : 'Short description'"
            />
            <mat-error *ngIf="item.get('identifier').value === 'title' && item.get('translation').hasError('required')">
              Study title is <strong>required</strong>
            </mat-error>
            <mat-error
              *ngIf="item.get('identifier').value === 'description' && item.get('translation').hasError('required')"
            >
              Short description is <strong>required</strong>
            </mat-error>
            <mat-error
              *ngIf="item.get('identifier').value === 'title' && item.get('translation').hasError('maxlength')"
            >
              Title should have
              <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong>
              characters
            </mat-error>
          </mat-form-field>
        </div>
      </ng-template>
    </div>

    <div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="10px">
      <label class="dashboard-study-details__form-label">Languages</label>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxFlex="50">
          <mat-chip-list aria-label="Languages selection">
            <mat-chip
              selected
              color="accent"
              [removable]="true"
              (removed)="removeLanguage(selectedLanguage)"
              *ngFor="let selectedLanguage of supportedLanguages"
            >
              {{ selectedLanguage?.name }}
              <mat-icon
                matChipRemove
                *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.STUDY_DETAILS, PRIVILEGE_ACTIONS.ALL)"
              >
                cancel
              </mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
        <div
          fxLayout="row"
          fxFlex="50"
          fxLayoutAlign="space-between stretch"
          fxLayoutGap="20px"
          *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.STUDY_DETAILS, PRIVILEGE_ACTIONS.ALL)"
        >
          <mat-form-field appearance="fill" fxFlex="100">
            <mat-label>Select language to add</mat-label>
            <mat-select (selectionChange)="selectLanguage($event.value)">
              <mat-option *ngFor="let language of mainLanguagesArray" [value]="language">{{
                language.name | titlecase
              }}</mat-option>
              <mat-optgroup label="Other Languages">
                <mat-option *ngFor="let language of otherLanguagesArray" [value]="language">{{
                  language.name | titlecase
                }}</mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
          <button mat-button color="primary" type="button" (click)="addLanguage()">
            {{ 'Add' | uppercase }}
          </button>
        </div>
      </div>
    </div>
    <dashboard-image-upload
      formControlName="imagePath"
      *ngIf="selectedStudyType === StudyType.TIIM"
      [label]="'Image or logo'"
      [isEdit]="isEdit"
      [isImageToEdit]="isImageToEdit"
      [imgPath]="imgPath"
      [keyForUpload]="keyForUpload"
      [idsForUpload]="idsForUpload"
      [autoUpload]="false"
    >
    </dashboard-image-upload>
    <div fxLayout="column" fxLayoutGap="10px">
      <div fxLayout="row" fxLayoutGap="30px">
        <mat-form-field>
          <input
            matInput
            [ngxMatDatetimePicker]="studyStartsPicker"
            placeholder="Study starts at"
            formControlName="startsAt"
            [max]="now"
          />
          <mat-datepicker-toggle matSuffix [for]="studyStartsPicker"></mat-datepicker-toggle>
          <ngx-mat-datetime-picker #studyStartsPicker [showSeconds]="false" [stepHour]="1" [stepMinute]="1">
          </ngx-mat-datetime-picker>
          <mat-error *ngIf="startsAt.hasError('required')"> Starts at is <strong>required</strong> </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input
            matInput
            [ngxMatDatetimePicker]="studyEndsPicker"
            placeholder="Study ends at"
            formControlName="endsAt"
            [min]="now"
          />
          <mat-datepicker-toggle [disabled]="false" matSuffix [for]="studyEndsPicker"></mat-datepicker-toggle>
          <ngx-mat-datetime-picker #studyEndsPicker [showSeconds]="false" [stepHour]="1" [stepMinute]="1">
          </ngx-mat-datetime-picker>
          <mat-error *ngIf="endsAt.hasError('required')"> Ends at is <strong>required</strong> </mat-error>
        </mat-form-field>
      </div>
      <mat-error *ngIf="startsAt.value && endsAt.value && studyDetailsForm.hasError('endDateInvalid')">
        Study Ends at must be a date after Starts at.
      </mat-error>
      <mat-error *ngIf="startsAt.value && endsAt.value && studyDetailsForm.hasError('startDateInvalid')">
        Study Starts at must be date and time before this moment.
      </mat-error>
    </div>
    <div fxLayout="row" *ngIf="selectedStudyType === StudyType.TIIM">
      <dashboard-color-picker
        [color]="isEdit ? selectedStudy?.color : color.value"
        (colorChange)="setColor($event)"
      ></dashboard-color-picker>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="column" fxLayoutGap="10px" *ngIf="selectedStudyType === StudyType.CC">
        <mat-checkbox formControlName="emailRequired">E-mail required</mat-checkbox>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="column" fxLayoutGap="10px" *ngIf="selectedStudyType === StudyType.CC">
        <mat-checkbox formControlName="feedback">Use feedback site for sending reporting results</mat-checkbox>
      </div>
      <div fxLayout="column" fxLayoutGap="10px">
        <mat-checkbox *ngIf="selectedStudyType !== StudyType.CC" formControlName="healthEnabled">
          Use biometric data collection (Google Fit & Health Kit)
        </mat-checkbox>
        <mat-checkbox *ngIf="selectedStudyType !== StudyType.CC" formControlName="phenotypingEnabled">
          Use digital phenotyping data collection (Battery life & GPS)
        </mat-checkbox>
      </div>
      <ng-container *ngIf="!isEdit; else updateView">
        <button mat-raised-button color="accent" (click)="saveStudy()" *dashboardHasRole="Role.CREATOR">
          {{ 'Create study' | uppercase }}
        </button>
      </ng-container>
      <ng-template #updateView>
        <button
          mat-raised-button
          color="accent"
          (click)="saveStudy()"
          *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.STUDY_DETAILS, PRIVILEGE_ACTIONS.ALL)"
        >
          {{ 'Update study' | uppercase }}
        </button>
      </ng-template>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="dashboard-study-details__error" *ngIf="selectedStudyType !== StudyType.CC">
        Unfortunately, the biometric data collection function is temporarily unavailable for Android. Our team is
        working on brining it back. We apologise for the inconvenience.
      </div>
    </div>
  </form>
</div>
